import React from 'react';
import { Facebook, Instagram, Youtube, Globe } from 'lucide-react';

/** X (Twitter) brand logo - stylized X */
export const XBrandIcon = ({ className = 'w-5 h-5', ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

function normalizePlatform(platform) {
  const v = (platform || '').toLowerCase();
  if (v === 'x' || v === 'twitter') return 'twitter';
  if (v === 'fb') return 'facebook';
  return v;
}

/**
 * Returns the icon component for a given platform string.
 * Use as: const IconComponent = getSocialLinkIcon(platform); <IconComponent className="w-4 h-4" />
 */
export function getSocialLinkIcon(platform) {
  const p = normalizePlatform(platform);
  if (p === 'twitter') return (props) => <XBrandIcon {...props} />;
  if (p === 'facebook') return Facebook;
  if (p === 'instagram') return Instagram;
  if (p === 'youtube') return Youtube;
  if (p.includes('campaign') || p.includes('website')) return Globe;
  return Globe;
}
